import {
  SECTION_CONTAINER_VARIANT_CONTENT_OVERFLOWED,
  SECTION_CONTAINER_VARIANT_NORMAL,
  SECTION_CONTENT_WIDTH_FULL,
  SECTION_CONTENT_WIDTH_NORMAL,
} from './constants';
import type { ContentWidthConfigMap, VariantConfigMap } from './types';

export const variantConfigMap: VariantConfigMap = {
  [SECTION_CONTAINER_VARIANT_NORMAL]: {
    className: 'isNormal',
  },
  [SECTION_CONTAINER_VARIANT_CONTENT_OVERFLOWED]: {
    className: 'isContentOverflowed',
  },
};

export const contentWidthConfigMap: ContentWidthConfigMap = {
  [SECTION_CONTENT_WIDTH_NORMAL]: {
    className: 'isContentNormal',
  },
  [SECTION_CONTENT_WIDTH_FULL]: {
    className: 'isContentFull',
  },
};
